/**
 * useIsNativeApp — the single runtime signal that distinguishes the native
 * Capacitor build from the web build, exposed as a hook for uniform, testable
 * call sites.
 *
 * The app ships as ONE JavaScript bundle to both web and native (a Capacitor
 * WebView wraps the full site). `isNativeApp` (from `@/lib/capacitor`) is
 * `Capacitor.isNativePlatform()` — a build-agnostic runtime constant that is
 * `false` on web and `true` inside the native shell. It is the ONLY reliable
 * web-vs-native discriminator inside a single bundle (an Unleash flag can't
 * tell them apart), which is exactly why "Pure Client v1" store gating keys
 * off it. See `docs/mobile-app/STORE-PURCHASE-STRATEGY.md`.
 *
 * Why a hook wrapping a constant?
 * - Keeps every gating call site uniform (`const isNative = useIsNativeApp()`).
 * - Gives one seam to mock in tests / Storybook without stubbing Capacitor.
 * - The underlying value never changes for the life of the process, so this is
 *   a pure pass-through with no state or effects — on web it is a compile-time
 *   `false`, making every gate a zero-cost no-op (web stays pixel-identical).
 */
import { isNativeApp } from '@/lib/capacitor';

export function useIsNativeApp(): boolean {
  return isNativeApp;
}
